<template>
  <div
    style="
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    "
  >
    <div
      style="
        position: absolute;
        top: 0;
        padding: 30px;
        color: #fff;
        height: 220px;
        border-bottom: 1px solid #f00;
        width: 100%;
        z-index: 99;
        font-size: 25px;
        font-weight: 600;
        padding-top: 80px;
      "
    >
      <!-- 您好,<br />
      欢迎使用“左才右财”薪酬管理系统审批工作台 -->
      "左才右财"薪酬管理系统
      <li style="text-align: right; font-size: 16px; padding-right: 30px">
        审批端
      </li>
    </div>
    <van-image
      :src="require('@/assets/images/login-top.png')"
      style="height: "
    />
    <div
      style="
        flex: 1;
        margin-top: -30px;
        border-radius: 10px;
        z-index: 99;
        background-color: #fff;
        padding: 40px;
        display: flex;
        flex-direction: column;
        padding-bottom: 20px;
      "
    >
      <van-form @submit="onSubmit(1)" v-if="state.loginType == 'zh'">
        <text style="font-weight: 600">手机号</text>
        <van-field
          v-model="state.sjh"
          style="border-bottom: 1px solid #e2e2e2; padding: 0; margin-top: 20px"
          placeholder="请输入手机号码"
          :rules="[
            { required: true, message: '请输入手机号码' },
            {
              pattern: $constant.pattern_phone,
              message: '请输入正确的手机号码',
            },
          ]"
        />
        <div style="font-weight: 600; margin-top: 40px">密码</div>
        <van-field
          v-model="state.mm"
          type="password"
          style="border-bottom: 1px solid #e2e2e2; padding: 0; margin-top: 20px"
          placeholder="请输入密码"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <div
          style="padding: 10px; display: flex; color: #a2a2a2; font-size: 12px"
        >
          <li style="flex: 1">忘记密码？</li>
          <li @click="state.loginType = 'yzm'">验证码登录</li>
        </div>
        <van-button
          type="primary"
          round
          style="margin-top: 40px; width: 100%; height: 50px"
          native-type="submit"
          >登录</van-button
        >
      </van-form>
      <van-form @submit="onSubmit(2)" v-else>
        <text style="font-weight: 600">手机号</text>
        <van-field
          v-model="state.sjh"
          style="border-bottom: 1px solid #e2e2e2; padding: 0; margin-top: 20px"
          placeholder="请输入手机号码"
          :rules="[
            { required: true, message: '请输入手机号码' },
            {
              pattern: $constant.pattern_phone,
              message: '请输入正确的手机号码',
            },
          ]"
        />
        <div style="font-weight: 600; margin-top: 40px">验证码</div>
        <van-field
          v-model="state.yzm"
          type="password"
          style="border-bottom: 1px solid #e2e2e2; padding: 0; margin-top: 20px"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请输入验证码' }]"
        >
          <template #button>
            <li
              v-if="!state.second"
              @click="onJudgeLocalSecond"
              style="color: #1e90ff; font-size: 13px"
            >
              发送验证码
            </li>
            <li v-else style="color: #a2a2a2; font-size: 13px">
              {{ state.second }}秒后重新发送
            </li>
          </template>
        </van-field>
        <div
          style="padding: 10px; display: flex; color: #a2a2a2; font-size: 12px"
        >
          <li style="flex: 1"></li>
          <li @click="state.loginType = 'zh'">账号密码登录</li>
        </div>
        <van-button
          type="primary"
          round
          style="
            margin-top: 40px;
            width: 100%;
            height: 50px;
            background-color: #a2a2a2;
            border: 0;
          "
          native-type="submit"
          disabled
          >登录</van-button
        >
      </van-form>
      <div
        style="
          font-size: 14px;
          flex: 1;
          display: flex;
          align-items: flex-end;
          justify-content: center;
        "
      >
        <text style="color: #a2a2a2">登录即表示同意</text><text>服务协议</text>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import dayjs from "dayjs";
import { useRouter } from "vue-router";
import { showNotify } from "vant";
import { judgeLogin } from "@/http/api";
export default {
  setup() {
    const router = useRouter();
    const state = reactive({
      loginType: "zh",
    });
    onMounted(() => {
      onJudgeLocalSecond();
    });

    //验证上一次发送验证码的时间，如果小于30秒则不允许再次发送，防止重复发送
    const onJudgeLocalSecond = (first) => {
      const time = localStorage.getItem("sendTime");
      if (time) {
        const localSecond = dayjs().diff(time, "second");
        if (localSecond < 30) {
          state.second = 30 - localSecond;
          let timer = setInterval(() => {
            state.second--;
            if (!state.second) {
              clearInterval(timer);
              localStorage.removeItem("sendTime");
            }
          }, 1000);
        } else {
          if (first) onSendValidate();
        }
      } else {
        if (first) onSendValidate();
      }
    };

    const onSendValidate = () => {
      state.second = 30;
      localStorage.setItem("sendTime", dayjs().format("YYYY-MM-DD HH:mm:ss"));
      let timer = setInterval(() => {
        state.second--;
        if (!state.second) {
          clearInterval(timer);
          localStorage.removeItem("sendTime");
        }
      }, 1000);
    };

    const onSubmit = (type) => {
      if (type == 1) {
        const data = { phone: state.sjh, password: state.mm };
        judgeLogin(data).then((res) => {
          if (res.status == 200) {
            localStorage.setItem("token", res.data.data?.token);
            router.replace("/");
          }
        });
      } else {
        showNotify({ type: "warning", message: "验证码登录功能暂未启用~" });
      }
    };

    return { state, onJudgeLocalSecond, onSendValidate, onSubmit };
  },
};
</script>
<style scoped></style>
